import  usePromotion from './usePromotion';
export default usePromotion
